import { create } from "zustand";

interface ServiceStatusState {
  /** The API answered 502/503/504: the backend is down or under maintenance. */
  isUnavailable: boolean;
  setUnavailable: (isUnavailable: boolean) => void;
}

export const useServiceStatusStore = create<ServiceStatusState>()((set) => ({
  isUnavailable: false,
  setUnavailable: (isUnavailable) => set({ isUnavailable }),
}));

export const UNAVAILABLE_STATUSES = [502, 503, 504];
